import Button from "../../components/shared/Button";
import "./Footer.scss";

import Telegram from "../../assets/icons/Telegram.svg";
import Twitter from "../../assets/icons/Twitter.svg";
import Gitbook from "../../assets/icons/Gitbook.svg";

import DexTools from "../../assets/images/dex-tools.png";
import DexScreener from "../../assets/images/dex-screener.png";
import CoinGecko from "../../assets/images/coin-gecko.png";

import { ArrowRight2 } from "iconsax-react";


export default function Footer() {
	return (
		<div className="footer">
			<div className="footer-content-wrapper content-wrapper-lg">
				<div className="social-card" id="community">
					<div className="social-title">Stay Connected</div>
					<ul className="social-items">
						<li className="social-item">
							<div className="social-item-card">
								<div className="social-item-title">
									Telegram
								</div>

								<div className="social-item-icon">
									<img src={Telegram} alt="Telegram Icon" />
								</div>

								<div className="social-item-btn">
									<Button className="join-btn" href="https://t.me/ChooseIrisAI">Join</Button>
								</div>
							</div>
						</li>

						<li className="social-item">
							<div className="social-item-card">
								<div className="social-item-title">X</div>

								<div className="social-item-icon">
									<img src={Twitter} alt="Twitter Icon" />
								</div>

								<div className="social-item-btn">
									<Button className="join-btn" href="https://x.com/teamiris_ai?s=21">Join</Button>
								</div>
							</div>
						</li>

						<li className="social-item">
							<div className="social-item-card">
								<div className="social-item-title">Gitbook</div>

								<div className="social-item-icon">
									<img src={Gitbook} alt="Gitbook Icon" />
								</div>

								<div className="social-item-btn">
									<Button className="join-btn" href="https://iriss-organization-2.gitbook.io/iris-ai/use-iris">Join</Button>
								</div>
							</div>
						</li>
					</ul>
				</div>

				<div className="footer-bottom row">
					<div className="left-col">
						<div className="footer-card footer-tools">
							<ul className="tool-items">
								<li className="tool-item">
									<a className="tool-item-card" href="#-">
										<div className="tool-item-title">
											Dex Tools
										</div>

										<div className="tool-item-img">
											<img src={DexTools} alt="Dex Tools" />
										</div>
									</a>
								</li>

								<li className="tool-item">
									<a className="tool-item-card" href="#-">
										<div className="tool-item-title">
											DexScreener
										</div>

										<div className="tool-item-img">
											<img
												src={DexScreener}
												alt="DexScreener"
											/>
										</div>
									</a>
								</li>

								<li className="tool-item">
									<a className="tool-item-card" href="#-">
										<div className="tool-item-title">
											CoinGecko
										</div>

										<div className="tool-item-img">
											<img
												src={CoinGecko}
												alt="CoinGecko"
											/>
										</div>
									</a>
								</li>
							</ul>
						</div>
					</div>

					<div className="right-col">
						<div className="footer-card footer-email">
							<div className="footer-email-desc">
								For General Inquiries and Partnership
								Opportunities, you can reach us at
							</div>

							<a
								href="mailto:teamirisai@gmail.com"
								className="footer-email-btn"
							>
								teamirisai@gmail.com

								<ArrowRight2 size="20" className="ms-auto" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
